module.exports = __webpack_public_path__ + "img/logo.33b34a4f.png";